<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <tamanio-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import TamanioProvider from "../../../providers/TamanioProvider";
    
    import {CrudCreate} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import TamanioForm from "../TamanioForm";
    
    


    export default {
        name: "TamanioCreate",
         
        components: { TamanioForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'tamanio.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    tamanio: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    TamanioProvider.createTamanio(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.tamanioCreate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

